import React from 'react';
import { TI_SOURCE_TYPES } from '../../triage/config';
import type { TriageItem } from '../../triage/types';
import { Icon } from '../Icon/Icon';

export interface TriageSourceLinkProps {
  item: TriageItem;
  style?: React.CSSProperties;
  onOpen?: (item: TriageItem) => void;
}

export function TriageSourceLink({ item, style, onOpen }: TriageSourceLinkProps) {
  const cfg = TI_SOURCE_TYPES[item.sourceType] ?? { icon: 'external' as const, label: 'Open source' };
  const detail = item.sourceLabel ? ` · ${item.sourceLabel}` : '';

  return (
    <button
      type="button"
      title={`${cfg.label}${detail}`}
      onClick={() => onOpen?.(item)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 7,
        padding: '6px 11px',
        borderRadius: 8,
        background: 'var(--cream-1)',
        color: 'var(--ink-1)',
        border: '1px solid var(--cream-2)',
        fontFamily: 'var(--font-body)',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '-0.005em',
        cursor: 'pointer',
        boxShadow: 'var(--sh-1)',
        ...style,
      }}
    >
      <Icon kind={cfg.icon} size={12} stroke={2} color="var(--ink-2)" />
      {cfg.label}
      <Icon kind="external" size={11} stroke={2} color="var(--ink-3)" />
    </button>
  );
}
